module.exports = __webpack_public_path__ + "img/make-it_desktop.373b5b5.jpg";